import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(_ctx.computedClasses),
    style: _normalizeStyle(_ctx.styles)
  }, null, 6))
}